export function mergeSizes(layouts: BannerLayout[]): BannerLayoutSize[] {
  const mergedSizes: { [key: string]: BannerLayoutSize } = {};
  layouts.forEach((layout) => {
    layout.sizes.forEach((size) => {
      if (!mergedSizes[size.name]) {
        mergedSizes[size.name] = size;
      }
    });
  });
  return Object.values(mergedSizes);
}
export const defaultQueryFilter = () => ({
  filter: '',
  page: 1,
  limit: 50,
  offset: 0,
});

export const defaultPaginatedData = () => ({
  meta: {
    total: 0,
    lastPage: 0,
    currentPage: 0,
    perPage: 0,
  },
  data: [],
});

export function formatDateHour(data, join = ' ') {
  if (!(data instanceof Date)) {
    data = new Date(data);
  }

  var dia = data.getDate();
  var mes = data.getMonth() + 1;
  var ano = data.getFullYear();
  var horas = data.getHours();
  var minutos = data.getMinutes();
  var segundos = data.getSeconds();

  dia = dia < 10 ? '0' + dia : dia;
  mes = mes < 10 ? '0' + mes : mes;
  horas = horas < 10 ? '0' + horas : horas;
  minutos = minutos < 10 ? '0' + minutos : minutos;
  segundos = segundos < 10 ? '0' + segundos : segundos;

  var dataFormatada =
    dia + '/' + mes + '/' + ano + join + horas + ':' + minutos + ':' + segundos;

  return dataFormatada;
}

export function formatDate(data) {
  if (!(data instanceof Date)) {
    data = new Date(data);
  }

  var dia = data.getDate();
  var mes = data.getMonth() + 1;
  var ano = data.getFullYear();

  dia = dia < 10 ? '0' + dia : dia;
  mes = mes < 10 ? '0' + mes : mes;

  return dia + '/' + mes + '/' + ano;
}

export function splitAndIdentifyPow(text: string): {
  splitText: string[];
  pow: boolean[];
} {
  const splitText: string[] = [];
  const pow: boolean[] = [];

  const regex = /(\$pow\(([^)]+)\))|\s+/g;

  let lastIndex = 0;
  let match;

  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      const normalText = text.slice(lastIndex, match.index).trim();
      if (normalText) {
        const parts = normalText.split(/\s+/);
        splitText.push(...parts);
        pow.push(...Array(parts.length).fill(false));
      }
    }

    if (match[2]) {
      splitText.push(match[2]);
      pow.push(true);
    }

    lastIndex = regex.lastIndex;
  }

  if (lastIndex < text.length) {
    const remainingText = text.slice(lastIndex).trim();
    if (remainingText) {
      const parts = remainingText.split(/\s+/);
      splitText.push(...parts);
      pow.push(...Array(parts.length).fill(false));
    }
  }

  return { splitText, pow };
}

export function splitByIndices(
  text: string,
  indices: [number, number][],
): { substrings: string[]; isIndexed: boolean[] } {
  const substrings: string[] = [];
  const isIndexed: boolean[] = [];

  let lastIndex = 0;

  indices.sort((a, b) => a[0] - b[0]);
  for (const [start, end] of indices) {
    if (start > lastIndex) {
      substrings.push(text.slice(lastIndex, start));
      isIndexed.push(false);
    }
    substrings.push(text.slice(start, end));
    isIndexed.push(true);
    lastIndex = end;
  }

  if (lastIndex < text.length) {
    substrings.push(text.slice(lastIndex));
    isIndexed.push(false);
  }

  return { substrings, isIndexed };
}
